var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReuseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.426,
    height: 31.094,
    viewBox: "0 0 34.426 31.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-reuse-2339548",
    transform: "translate(-42 -94.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8369",
    "data-name": "Group 8369",
    transform: "translate(41 90.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8368",
    "data-name": "Group 8368",
    transform: "translate(1 4.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9589",
    "data-name": "Path 9589",
    d: "M30.7,14.009a.714.714,0,0,0,.356-.537l.454-3.927-1.414-.163L29.9,11,25.728,4.369a.706.706,0,0,0-.609-.332.718.718,0,0,0-.6.345L16.545,17.661l1.219.735L25.141,6.107l3.651,5.8-1.766-.8-.586,1.3,3.613,1.637a.711.711,0,0,0,.643-.03Z",
    transform: "translate(-7.914 -4.037)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9590",
    "data-name": "Path 9590",
    d: "M8.931,33.287l.193,1.765,1.414-.156-.43-3.93a.712.712,0,0,0-1-.572L5.49,32.008l.579,1.3,1.623-.723L1.1,43.564a.712.712,0,0,0,.61,1.079H22.251V43.219H2.969Z",
    transform: "translate(-1 -15.732)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9591",
    "data-name": "Path 9591",
    d: "M53.059,40,42.444,22.317l-1.219.735,9.967,16.6H43.731l1.33-1.12-.916-1.09-3.016,2.54a.712.712,0,0,0,.077,1.145l3.347,2.132.763-1.2-1.539-.981H52.45A.712.712,0,0,0,53.059,40Z",
    transform: "translate(-18.735 -12.167)",
    fill: "#404040"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuseIcon);
export default __webpack_public_path__ + "static/media/reuse-icon.55970ebea440552de59e5493b9ea9a90.svg";
export { ForwardRef as ReactComponent };